import React from "react";
import { useControlCenterState } from "./hooks/useControlCenterState";
import { ControlCenterDataLoadable } from ".";

export const ControlCenterLoader = () => {
  const enabled = useControlCenterState();
  return enabled && <ControlCenterDataLoadable />;
};
